// This function processes a new name for a configuration

function convertName(oldName) {
  try {
    return oldName
      //.replace(/(<)([\w!?/])/g, ' $2') // replaces '<' before '!', '/', '?' or a letter with the space char
      .replace(/(&)([\d\w#])/g, ' $2') // replaces '&' before '#', a digit or a letter with the space char
      .replace(/\s{2,}/g, ' ') // contracts the long spaces inside of the string
      .trim(); // removes spaces from the beginning and the end of the string

  } catch (e) {
    return oldName;
  }
}

export default convertName;
